import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProductsRetailerSearchDataService } from 'src/app/_services';
import { asArray, IEnumValue, ProductField, Bool, asBoolArray, LxmAppModule } from 'src/app/enum';
import { AppState } from 'src/app/state/app.state';
import { ICountryTranslated, IRetailerProductsSearchFormData, IClvDto, IAssortmentGroup, ILocationOption, ISegmentTreeOption } from 'src/app/cards/product/product-info/product-info.model';
import { ActivatedRoute } from '@angular/router';
import { LocalStorage } from 'src/app/_helpers';
import { AssortmentMovement } from 'src/app/enum/assortment-movement';
import { ProductsListState } from 'src/app/cards/products/products-list.state';
import { Guid } from 'src/app/util/Guid';

@Component({
  selector: 'product-search-retailer-card',
  templateUrl: './product-search-retailer.html',
  host: { 'class': 'product-search-retailer-card' },
  styleUrls: ['./product-search-retailer.scss']
})
export class RetailerProductsSearchCard implements OnInit {

  public formData: IRetailerProductsSearchFormData;

  @Output()
  public search = new EventEmitter();

  @Input()
  public isOpen = false;

  @Input()
  private localStorageKey: string;

  public assortmentStatusOptions: IClvDto[];
  public assortmentGroupOptions: IAssortmentGroup[];
  public locationOptions: ILocationOption[];
  public allergenOptions: IClvDto[];
  public isInCampaignOptions = asBoolArray(Bool);
  public assortmentMovementOptions = asArray(AssortmentMovement);

  private searchKey: string;

  public countryOptions: ICountryTranslated[];
  public nutritionalClaimsOptions: IEnumValue[];

  public hasAssortment: boolean;

  public segmentOptions: ISegmentTreeOption[];

  public searchAllergenContentOptions = [
    { name: 'enums.ProductAllergenContentType.MayContain', id: 1 },
    { name: 'enums.ProductAllergenContentType.Contains', id: 2 },
    { name: 'enums.ProductAllergenContentType.DoesNotContain', id: -1 }
  ];

  constructor(
    private _state: ProductsListState,
    public appState: AppState,
    private _productsSearchDataService: ProductsRetailerSearchDataService,
    route: ActivatedRoute) {
    this.hasAssortment = this.appState.hasModule(LxmAppModule.BuyerAssortment);

    this.formData = (route.snapshot.data.formData || route.snapshot.data.productCard.formData) as IRetailerProductsSearchFormData;
    this.segmentOptions = this.formData.segmentTreeOptions;

    this.countryOptions = this.formData.countries;

    this.assortmentStatusOptions = this.formData.assortmentStatuses || [];
    this.assortmentStatusOptions.push({
      id: Guid.empty,
      code: "-1",
      value: "cards.products.products_retailer_search.label.noStatus"
    });

    this.assortmentGroupOptions = this.formData.assortmentGroups;
    this.locationOptions = this.formData.locations;
    this.nutritionalClaimsOptions = asArray(ProductField).filter(x => this.formData.nutritionalClaims?.includes(x.id));
    this.allergenOptions = this.formData.allergens;
  }

  public get searchData(): FormGroup {
    return this._productsSearchDataService.searchData;
  }

  public get isLoading() {
    return this._state.isSearchLoading;
  }

  public get showAllergensFilter(): boolean {
    return this._productsSearchDataService.searchData.get("allergenContentType").value;
  }

  public segmentTreeLabel(i: ISegmentTreeOption) {
    return `${'--'.repeat(i.level)} ${i.code} ${i.name}`.trim();
  }

  public disableOption(i: ISegmentTreeOption) {
    return !i.canAssignToProduct;
  }

  public toggleOpen(isOpen: boolean) {
    this.isOpen = isOpen;
    LocalStorage.set(this.localStorageKey, isOpen);
  }

  public ngOnInit(): void {
    this.submit();
  }

  public submit() {
    const val = this._productsSearchDataService.serializeSearchData();
    this.search.emit(val);
  }

}
